// @ts-strict-ignore

import {EventDefinition, LookupTableDefinition, PropertyDefinition} from 'apps/lexicon/src/models';
import {Metric} from 'app_api/projects/metrics/types';
import {BehaviorEntity as Behavior} from 'app_api/projects/behaviors/types';

/** Represents "Users" or no Data Group in the UI. We would just use `null` but some controls can't match values if we do. */
export const DEFAULT_DATA_GROUP_ID: string = `$default_data_group_id`;

/* eslint-disable @typescript-eslint/naming-convention */
export const enum BulkActions {
  hide = `bulkHide`,
  unhide = `bulkUnhide`,
  dismissWarnings = `bulkDismissWarnings`,
  dismiss = `bulkDismiss`,
  drop = `bulkDrop`,
  undrop = `bulkUndrop`,
  mapToLookupTable = `bulkMapToLookupTable`,
  unMapFromLookupTable = `bulkunMapFromLookupTable`,
  upgradeToMapToLookupTable = `upgradeToMapToLookupTable`,
  merge = `bulkMerge`,
  markSensitive = `bulkMarkSensitive`,
  unmarkSensitive = `bulkUnmarkSensitive`,
  unmerge = `bulkUnmerge`,
  tag = `bulkTag`,
  delete = `bulkDelete`,
  download = `bulkDownload`,
  moreActionsOverflow = `dropdownAction`,
  editOwnership = `editOwnership`,
  verify = `bulkVerify`,
}

export type LexiconDefinition = EventDefinition | PropertyDefinition | LookupTableDefinition | Metric | Behavior;
export type IndexedPropertyDefinition = {[name: string]: PropertyDefinition};
export type IndexedLookupTableDefinition = {[name: string]: LookupTableDefinition};

export enum DataVolumeAnomalyStatus {
  Open = `open`,
  Dismissed = `dismissed`,
}

export type DataVolumeAnomaly = {
  id: number;
  event?: number; // event ID
  event_name?: string;
  property?: number; // property ID
  property_name?: string;
  timestamp: number | null;
  actual_count: number;
  predicted_upper: number;
  predicted_lower: number;
  percent_variance: string;
  status?: DataVolumeAnomalyStatus;
};

export enum View {
  // Data management views
  Behaviors = `behaviors`,
  Cohorts = `cohorts`,
  CustomEvents = `custom-events`,
  CustomEventProperties = `custom-event-properties`,
  EventProperties = `event-properties`,
  Events = `events`,
  Formulas = `formulas`,
  LookupTables = `lookup-tables`,
  Metrics = `metrics`,
  ProfileProperties = `profile-properties`,
  CustomProfileProperties = `custom-profile-properties`,

  // Settings view
  EventApproval = `event-approval`,
  DataDeletion = `advanced-deletion`,
  DataRules = `data-rules`,
  VolumeMonitoring = `volume-monitoring`,
  Issues = `issues`,
}

export enum Status {
  Loading = `loading`,
  Success = `success`,
  Error = `error`,
}

export const LexiconEntitySpecialCharEscapeMap: Record<string, string> = {
  '\n': `$mp-nl`,
  '\t': `$mp-tab`,
  '\r': `$mp-cr`,
};
